import React from "react";
import Nav from "../components/Nav";
import Payment_2 from "../components/paymentPage_2/Payment_2";
import Footer from "../components/Footer";

const Crowdfunding_2 = () => {
  return (
    <div className="Crowdfunding_2 flex h-screen items-center">
      <div className="">
        <Payment_2 />
      </div>
    </div>
  );
};

export default Crowdfunding_2;
